export default __webpack_public_path__ + "static/media/solution_70.13a66ea7.svg";